import { useQuery } from '@apollo/client';

import { EventProduct, getCompletedDeliveryEventDetails } from '@/api';

import { DeliveryEventVendorDetailsCompleted, DeliveryEventVendorFinancialDetails } from '../types';
import { parseEventVendorIds, sumFinancialSummaries } from '../helpers';

type UseDeliveryCompletedEvent = {
  event: DeliveryEventVendorDetailsCompleted | undefined;
  financialSummary: DeliveryEventVendorFinancialDetails | null;
  loading: boolean;
};

// The card stands for a whole manifest, so the financial summary is the sum
// across its events. Null unless every requested event came back: a partial
// total would understate the restaurant's money instead of failing visibly.
export const useDeliveryCompletedEvent = (id: string): UseDeliveryCompletedEvent => {
  const requestedIds = parseEventVendorIds(id);

  const { data, loading } = useQuery(getCompletedDeliveryEventDetails, {
    variables: { input: { eventVendorIds: requestedIds, productType: EventProduct.DELIVERY } },
  });

  const members = data?.getEventVendors?.eventVendors as
    | DeliveryEventVendorDetailsCompleted[]
    | undefined;

  return {
    event: members?.[0],
    financialSummary:
      members?.length === requestedIds.length ? sumFinancialSummaries(members) : null,
    loading,
  };
};
